import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from '@optsolservices/ngx-notification';
import { BaseService } from 'src/app/core/services/base.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-syspro-order-deliver-fee-dialog',
  templateUrl: './syspro-order-deliver-fee-dialog.component.html',
  styleUrls: ['./syspro-order-deliver-fee-dialog.component.scss']
})
export class SysproOrderDeliverFeeDialogComponent implements OnInit {
  form: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<SysproOrderDeliverFeeDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private notificationService: NotificationService,
  ) {
    this.form = fb.group({
      km: [null, Validators.compose([Validators.required, Validators.min(0), Validators.max(10000)])],
    });
  }

  ngOnInit() {
    console.log('this.data: ', this.data);
  }

  save() {
    const dialogData: OiGroupDialogData = {
      title: 'Adding Delivery Fee To Order In Syspro',
      function: 'portal_oi_group_syspro_order_add_delivery_fee',
      postBody: {
        salesOrderNumber: this.data.salesOrderNumber,
        ...this.form.getRawValue(),
      }
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      if (oiResult.responseCode === 0) {
        this.notificationService.success('Delivery Fee Added');
        this.dialogRef.close(true);
      }
    });
  }
}
